import * as angular from 'angular';

import { ComponentDefinition } from '../../models';

class UserDetailsController implements angular.IComponentController {
    isLoading: boolean;
    user: any;
    
    readonly isPictureLoaded: boolean;
    readonly userName: string;

    static $inject = [];
}

export const wtUserDetails: ComponentDefinition = {
    componentId: 'wtUserDetails',
    controller: UserDetailsController,
    template: require('./userDetails.component.html'),
    controllerAs: 'vm',
    bindings: {
        isPictureLoaded: '<',
        user: '=',
        userName: '<'
    }
};
